import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import Api from '../lib/server.js'
import globalFn from '../lib/globalFn.js'
import router from '../router/router.js';

import that from '../main.js';
// import { Message } from 'element-ui'
// ↓ 从 sessionStorage 中读取的 asideTree 数据，用于放入 state.asideTree 中
const asideTree = JSON.parse(sessionStorage.getItem('asideTree'));
console.log('%c%s','color:red;','asideTree: ', asideTree);

const state = {
  //↓页面尺寸
  screenSize:{
    width: 0,
    height: 0
  },
  //↓二级功能路由尺寸
  mainViewSize:{
    width: 0,
    height: 0
  },
  //留言人身份数组
  peopleTypeArr:[
    {id:0,name:"无"},
    {id:1,name:"全国代表委员"},
    {id:2,name:"省代表委员"},
    {id:3,name:"全国政协委员"},
    {id:4,name:"省政协委员"}
  ],
  //↓是否是登录状态：0为未登录，1为已登录
  logged: sessionStorage.getItem('logged') == '1' ? 1 : 0,
  //↓用户信息
  user: {
    username: '',
    'Access-Token': '',
    avatar: '',
    cid: null,
    companyName: '',
    last_login_ip: null,
    last_login_time: null,
    nickname: '',
    role: null,
    roleList: [],
    role_name: '',
    uid: null,
  },
  // // ↓ 切换 客户(公司) 弹窗数据
  // switchCompanyDialog:{
  //   /* ↓ 弹窗显隐 */
  //   seen: false,
  //   /* ↓ 是否在请求中，弹窗显示遮罩，同时判断是否需要阻止手动关闭 */
  //   loading: false,
  //   /* ↓ 搜索内容 */
  //   searchInfo:{},
  //   /* ↓ 表格数据 */
  //   gridData: [],
  //   /* ↓ 表格列名 */
  //   colArr: [{
  //     label: '客户名称',
  //     sortable: true,
  //     value: 'Name',
  //   }],
  //   /* ↓ 分页 */
  //   pageSizeArr: [10,20,50],
  //   pageSize: 10,
  //   currentPage: 1,
  //   total: 0,
  // },
  // ↓ 所属单位、角色 等
  relativeJson: {
		deJson: [],	// 设备
    btJson: [], // 客户(单位)类型 多选
    roJson: [], // 用户角色 单选
    inJson: [], // 意图 + 领域
  },
  questionStatus:[{
      value: 0,
      title: '待学习'
    },{
      value: 1,
      title: '已学习'
    },{
      value: 2,
      title: '忽略'
  }],
  systemName: '',
  pageNameList: [],
  //↓侧边目录树信息
  asideTree:{
    system: asideTree ? asideTree.system : '',
    json: asideTree ? asideTree.json : [],
    checkedNode: asideTree ? asideTree.checkedNode : {}
  },
  // ↓ 整个页面 loading 遮罩
  fullSizeLoading: false,
  /**
   *↓ 业务问答/问答库 中
   *  左侧分类树的 数据、增删改权限
   */
  QATree:{
    list: [],
    checkedNode: {
      id: 1,
      name: "默认分类",
      pid: 0
    }
  },
  /* ↓ 预览 图片 or 视频 多媒体答案 弹窗 */
  previewMedia:{
    seen: false,
		type: '',
		name: '',
    path: '',
  },
};
const mutations = {
  /**
   * ↓ 设置 是否已登录
   */
  setLogonStatus(state, val){
    state.logged = val;
    sessionStorage.setItem('logged',JSON.stringify(state.logged));
  },
  /**
   * ↓ 设置 用户信息
   */
  setUser(state,opt){
    state.user = opt;
    sessionStorage.setItem('user',JSON.stringify(state.user));
  },
  /**
   * ↓ 退出登录
   */
  logOut(){
    // console.log(this.BaseURL);
    // // 结果: undefined
    // // 原因:  这里this的指向是Store

    // console.log(Vue.BaseURL);
    // // 结果: undefined

    // console.log(window.BaseURL)
    // window.BaseURL = '2'
    // console.log(window.BaseURL)
    // return
    globalFn.axiosPost({
      url: Api.logOut,
      failTip: '退出登录失败',
      success: res => {
        // Message.closeAll();
        globalFn.showMES('退出登录成功','success');
        this.commit('setUser',{});
        this.commit('setLogonStatus', 0);
				this.commit('setPageNameList', '');
        router.push({name:'LogInPage'});
      }
    });
  },
  /**
   * ↓ 获取相关数据 角色数据、客户
   */
  setRelativeJson(state, data){
		state.relativeJson = data;
		
    console.log('%c%s','color:red',
      'relativeJson:\n',
      globalFn.deepClone(state.relativeJson)
    );
	},
	/**
	 * ↓ 设置 二级功能路由 尺寸
	 */
	setMainViewSize(state, size){
		state.mainViewSize = size;
		console.log('mainViewSize now ↓\n',Object.assign({}, state.mainViewSize))
	},
  /**
   * ↓ 设置 screenSize
   */
  setScreenSize(state){
    state.screenSize = {
      width: document.documentElement.clientWidth,
      height: document.documentElement.clientHeight,
		};
		// console.log('screenSize ↓\n',Object.assign({}, state.screenSize))
  },
  /**
   * ↓ 开启 监听窗口尺寸变化时，(防抖)更新screenSize
   */
  startUpdateScreeSzie(state){
    let timeout1 = null;
    let timeout2 = null;
    window.addEventListener('resize',() => {
      if (timeout1 !== null) clearTimeout(timeout1);
      timeout1 = setTimeout(()=>{
        let width = document.documentElement.clientWidth;
        let height = document.documentElement.clientHeight;
        state.screenSize = {
          width: width, // < 1253 ? '1253px' : width,
          height: height
        };
        //console.log('screenSize ↓\n',Object.assign({}, state.screenSize))
        if (timeout2 !== null) clearTimeout(timeout2);
        timeout2 = setTimeout(()=>{
          let width = document.documentElement.clientWidth;
          let height = document.documentElement.clientHeight;
          state.screenSize = {
            width: width,
            height: height
          };
          console.log('screenSize now ↓\n',Object.assign({}, state.screenSize))
        }, 30);
      }, 800);
    });
  },
  setSystemName(state, name){
    state.systemName = name;
  },
  /**
   * ↓ 设置MainPage.vue中的侧边目录树(Aside.vue)数据
   */
  setAsideTree(state, opt){
    const json = opt.json ? opt.json : state.asideTree.json;
    const system = opt.system ? opt.system : state.asideTree.system;
    const checkedNode = opt.checkedNode ? opt.checkedNode : state.asideTree.checkedNode;

    state.asideTree = {
      system: system,
      json: json,
      checkedNode: checkedNode
    };
    sessionStorage.setItem('asideTree', JSON.stringify(state.asideTree));
  },
  /**
   * ↓ 设置默认选中的 x级菜单(第一个最末位子级菜单), 同时路由跳转
   */
  setTreeAndRoute(state, treeJson){
		state.pageNameList = [];
		console.log('treeJson:', treeJson);
    const firstMenu = treeJson[0];

    if(firstMenu.children){
      // ↓ 如果第一个一级菜单有children，设置默认选中其children中第一个或者第一个还有children继续往下选择
      state.pageNameList.push(firstMenu);
      this.commit('getLastMenu',{
        arr: firstMenu.children,
        treeJson: treeJson
      });
    }else{
      // ↓ 如果第一个一级菜单无children，直接设置默认选中第一个
      state.pageNameList.push(firstMenu);

      this.commit('setAsideTree',{
        json: treeJson,
        checkedNode: firstMenu
      });
			// router.push({ name: firstMenu.url_type });
			console.log('route name:', that.$route.name)
			console.log('firstMenu.url_type:', firstMenu.url_type)
			if(that.$route.name == firstMenu.url_type){
				that.$router.go(0);
				return
			}
			router.replace({ name: firstMenu.url_type });
			// 
    };
  },
  /**
   * ↓ 获取tree json 中第一个一级菜单的最末位子级菜单并跳转
   *   参数:
   *    opt.arr
   *    opt.treeJson
   */
  getLastMenu(state, opt){
    const childArr = opt.arr;
    if(!childArr[0].children){
      state.pageNameList.push(childArr[0]);
      this.commit('setAsideTree',{
        json: opt.treeJson,
        checkedNode: childArr[0]
      });

      router.push({ name: childArr[0].url_type });
    }else if(childArr[0].children){
      state.pageNameList.push(childArr[0]);
      this.commit('getLastMenu',{
        arr: childArr[0].children,
        treeJson: opt.treeJson
      });
    };
  },
  setPageNameList(state, list){
		state.pageNameList = list;
		sessionStorage.setItem('pageNameList', JSON.stringify(state.pageNameList));
  },
  /**
   * ↓ 设置全屏区域 loading 遮罩
   */
  setFullSizeLoading(state, bool){
    state.fullSizeLoading = bool
  },
  /**
   *↓ 获取 业务问答/问答库 中
   *  左侧分类树的 数据
   */
  getQATreeList(state){
    // const data = require('../../testData/QABaseTree.js').default;
    // const QATree = Object.assign(this.QATree, { list: data });
    globalFn.axiosPost({
      url: Api.BusinessQA.QABase.treeGet,
      failTip: '获取 问答分类目录树数据 失败',
      success: res => {
        this.commit('setQATree',{ list: res.data.data });
      }
    })
  },
  /**
   *↓ 设置 业务问答/问答库 中
   *  左侧分类树的 数据、增删改权限
   */
  setQATree(state,opt){
    const list = opt.list ? opt.list : state.QATree.list;
    const checkedNode = opt.checkedNode && opt.checkedNode.id ? opt.checkedNode : state.QATree.checkedNode;
    state.QATree = {
      list: list,
      checkedNode: checkedNode
    };
  },
  /* ↓ 设置 预览 多媒体答案 弹窗 中 数据 */
  setPreviewMedia(state,opt){
    state.previewMedia = opt;
  },
};
const store = new Vuex.Store({
  state,
  mutations
})
export default store



// WEBPACK FOOTER //
// ./src/store/store.js